import { render, staticRenderFns } from "./zhihuizhengwu.vue?vue&type=template&id=cb37951e&scoped=true&"
import script from "./zhihuizhengwu.vue?vue&type=script&lang=js&"
export * from "./zhihuizhengwu.vue?vue&type=script&lang=js&"
import style0 from "./zhihuizhengwu.vue?vue&type=style&index=0&id=cb37951e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb37951e",
  null
  
)

export default component.exports